var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 7H9V2a1 1 0 1 0-2 0v5H2a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0V9h5a1 1 0 1 0 0-2"}));
}

Plus.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Plus;

Plus.default = Plus;
